export default __webpack_public_path__ + "static/media/404-settings.ca08dd96.svg";